export const convertRateValue = (value: string): string => {
  return `$${Number(value).toFixed(2)}/mo`;
};
